export const DEFAULT_DELAY = 200;
export const DEFAULT_DURATION = 900;
